import { nextReduxWrapper } from '../../src/client/store/create-store';
import fetchAllProductData from '../../src/client/models/product/fetch-all-product-data';
import Sitemap from '../../src/client/pages/sitemap';

export const getServerSideProps = nextReduxWrapper.getServerSideProps((store) => async () => {
  await fetchAllProductData(store.getState(), store.dispatch);
  return { props: {} };
});

export default Sitemap;
